import { Injectable } from '@angular/core';
import { HttpClientService } from '../httpClient/httpclient.service';
import { BackofficeSystem } from '../../models/backoffice-system.model';
import 'rxjs/Rx';
import { MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs/Observable';
import { publishReplay, refCount } from 'rxjs/operators';

@Injectable()
export class BackofficeSystemService {

  items: BackofficeSystem[];
  itemEditing: BackofficeSystem;
  private cachedFields: Observable<any>;

  constructor(
    private h: HttpClientService,
    private srvNotify: MessageService,
    private translate: TranslateService
  ) { }

  private notifySuccess() {
    this.translate.get(['common.success', 'common.operation_success']).subscribe(res => {
      this.srvNotify.add({ severity: 'info', summary: res['common.success'], detail: res['common.operation_success'] });
    });
  }

  list(
    offset = null,
    limit = null,
    search?: Array<{ key: string, value: string }>,
    globalSearch?: string,
    sort?: string,
    sort_dir?: number
  ): Observable<any> {
    const params = HttpClientService.buildListParams(offset, limit, search, globalSearch, sort, sort_dir);
    return this.h.getPaged('/koncentro-common/back-office' +
      (params.toString() ? '?' + params.toString().replace(/\+/gi, '%2B').replace(/'/gi, "''") : ''));
  }

  getAll() {
    return this.h.get('/koncentro-common/back-office')
      .map(res => {
        return this.items = res;
      });
  }

  getById(id) {
    return this.h.get('/koncentro-common/back-office/' + id);
  }

  delete(record) {
    return this.h.delete('/koncentro-common/back-office/' + record.id)
      .map(res => {
        this.notifySuccess();
      });
  }

  post(newData, silent = false) {
    return this.h.post('/koncentro-common/back-office', newData, silent)
      .map(res => {
        newData.id = res.id;
        this.notifySuccess();
      });
  }

  put(newData, silent = false) {
    return this.h.put('/koncentro-common/back-office/' + newData.id, newData, silent)
      .map(res => {
        Object.assign(this.itemEditing, newData);
        this.notifySuccess();
      });
  }

  recover(record) {
    const data = Object.assign({}, record, { flg_state: 0 });
    return this.h.put('/koncentro-common/back-office/' + record.id, data)
      .map(res => {
        this.notifySuccess();
      });
  }

  getFields() {
    if (!this.cachedFields) {
      this.cachedFields = this.h.get('/koncentro-common/schema/BackOfficeDto').pipe(
        publishReplay(1),
        refCount()
      );
    }
    return this.cachedFields;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/backoffice-system/backoffice-system.service.ts